import { createBasicSelector } from 'util/redux'
import { emptyArr } from 'util/arrays'
import { selectBase } from './selectBase'

export const selectPlans = createBasicSelector(
  selectBase,
  base => base.plans || emptyArr
)
